export default __webpack_public_path__ + "static/grid-tablet-and-desktop-8b48c1f7ebe7606d0a2959917477bfe5.png";